import { useRouteMatch } from "react-router-dom";
import { useMemo } from "react";

export const useCurrentMerchantId = () => {
  const match = useRouteMatch<{ merchantId: string }>(
    "/merchants/:merchantId/",
  );
  const { merchantId } = useMemo(() => match.params, [match]);
  return merchantId;
};
